// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"MainContainer_mainContainer__JU6s5"};